import { normalizeCarConditionSheet } from '@/utils/carCondition';
import { normalizeCarDetailedData } from '@/utils/carDetails';
import { publicAssetUrl } from '@/utils/publicAssetUrl';
const API_BASE = process.env.API_BASE_URL ?? '';
/** Abszolút production /pictures|/uploads URL → same-origin. */
function localizePicturesUrl(url) {
    if (typeof url !== 'string' || !url.trim())
        return undefined;
    const match = url.trim().match(/\/(?:pictures|uploads)\/[^?#]+/);
    if (match)
        return publicAssetUrl(match[0]);
    return url.trim();
}
function normalizeValto(value) {
    const v = String(value ?? '').toLowerCase();
    if (v.includes('automat') || v.includes('dsg') || v.includes('tiptronic') || v.includes('cvt')) {
        return 'Automatikus';
    }
    return 'Manuális';
}
function normalizeUzemanyag(value) {
    const v = String(value ?? '').toLowerCase();
    if (v.includes('dízel') || v.includes('dizel') || v.includes('tdi') || v.includes('cdti'))
        return 'Dízel';
    if (v.includes('elektrom') && !v.includes('benzin') && !v.includes('dízel'))
        return 'Elektromos';
    if (v.includes('hibrid') || v.includes('elektrom'))
        return 'Hibrid';
    if (v.includes('lpg') || v.includes('gáz') || v.includes('gaz'))
        return 'LPG';
    return 'Benzin';
}
async function apiGet(path) {
    const res = await fetch(`${API_BASE}${path}`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
    });
    if (!res.ok) {
        throw new Error(`API hiba (${res.status}): ${path}`);
    }
    return res.json();
}
function normalizeCar(raw) {
    const kepUrl = localizePicturesUrl(raw.kepUrl) ?? raw.kepUrl;
    const imageUrls = Array.isArray(raw.imageUrls)
        ? raw.imageUrls.map((u) => localizePicturesUrl(u) ?? u).filter(Boolean)
        : kepUrl
            ? [kepUrl]
            : [];
    return {
        ...raw,
        uzemanyag: normalizeUzemanyag(raw.uzemanyag),
        valto: normalizeValto(raw.valto),
        kepUrl: imageUrls[0] || kepUrl,
        imageUrls: imageUrls.length > 0 ? imageUrls : undefined,
        elkelt: Boolean(raw.elkelt),
        detailedData: normalizeCarDetailedData(raw.detailedData, raw),
        conditionSheet: normalizeCarConditionSheet(raw.conditionSheet, raw),
    };
}
/** Tartalék, ha az API üres / elérhetetlen. */
async function fetchImportedCars() {
    try {
        const res = await fetch(`${API_BASE}/data/imported_cars.json`, {
            headers: { Accept: 'application/json' },
            credentials: 'same-origin',
            cache: 'no-store',
        });
        if (!res.ok)
            return null;
        const ct = res.headers.get('content-type') || '';
        if (!ct.includes('application/json') && !ct.includes('text/json')) {
            // SPA fallback HTML (nincs JSON a szerveren)
            return null;
        }
        const data = (await res.json());
        const cars = (data.cars ?? []).map(normalizeCar);
        return cars.length > 0 ? cars : null;
    }
    catch {
        return null;
    }
}
export async function fetchCarsFromApi() {
    try {
        const data = await apiGet('/api/cars.php');
        const cars = (data.cars ?? []).map(normalizeCar);
        if (cars.length > 0)
            return cars;
    }
    catch {
        /* fallback below */
    }
    const imported = await fetchImportedCars();
    if (imported)
        return imported;
    return [];
}
export async function fetchCarFromApi(id) {
    try {
        const data = await apiGet(`/api/car.php?id=${encodeURIComponent(id)}`);
        return data.car ? normalizeCar(data.car) : null;
    }
    catch {
        return null;
    }
}
export async function fetchSiteFromApi() {
    const data = await apiGet('/api/site.php');
    const site = data.site;
    const logoUrl = localizePicturesUrl(site.logoUrl);
    const heroAutoImage = localizePicturesUrl(site.heroAutoImage);
    return {
        ...site,
        ...(logoUrl ? { logoUrl } : {}),
        ...(heroAutoImage ? { heroAutoImage } : {}),
    };
}
export async function isApiAvailable() {
    try {
        await fetch(`${API_BASE}/api/site.php`, { method: 'GET', headers: { Accept: 'application/json' } });
        return true;
    }
    catch {
        return false;
    }
}
